<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import CompanyEdit from "@/components/company/form/CompanyEdit";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Table from "@/components/company/components/EmployeeTable";
import ClassificationModal from "@/components/company/components/ClassificationModal.vue";
import cargaMasivaModal from "@/components/company/components/cargaMasivaModal.vue";
import BrandingSection from "@/components/branding/BrandingSection.vue";
import DocumentControlSection from "@/components/documentControl/DocumentControlSection.vue";
import SignaturesManager from "@/components/branding/SignaturesManager.vue";

/**
 * Tabs & Accordions component
 */
export default {
  page: {
    title: "Gestión empresa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CompanyEdit,
    Table,
    ClassificationModal,
    cargaMasivaModal,
    BrandingSection,
    DocumentControlSection,
    SignaturesManager,
  },
  data() {
    return {
      title: "Gestión empresa",
      items: [
        {
          text: "Gestión empresa",
          href: "/forms/listado-empresa",
        },
        {
          text: "Editar empresa",
          active: true,
        },
      ],

      tipoPersona: "",
      nit: "",
      nombre: "",
      nombreSede: "",
      direccion: "",
      telefono: "",

      file: null,
      cargaEmployee: {
        file: null,
      },

      id: 0,

      companyData: {
        type: null,
        uuid: null,
        sso_id: null,
        ciu_id: null,
        arl_id: null,
        company_classification_id: 5,
        legal_representative: null,
        legal_representative_email: null,
      },

      arls: [],
      cius: [],

      employeeList: [],
      totalEmployee: 0,

      showNotification: false,
      message: "",

      companyID: this.$route.params.id,

      perPage: 10,
      currentPage: 1,

      exportStatus: 'all',

      exist: false,

      loading: true,
      loading1: true,

      usersList: [],
      userSelected: null,

      fields: [
        {
          key: "full_name",
          label: "Nombre de colaborador",
        },
        {
          key: "is_active",
          label: "Estado",
        },
        {
          key: "risk_class",
          label: "Clase de riesgo",
        },
        {
          key: "actions",
          label: "Acciones",
        },
      ],
    };
  },
  methods: {
    goPage(url) {
      window.location.reload();
      window.location.href = url;
    },

    reload() {
      window.location.reload();
    },

    goBack() {
      this.$router.push("/forms/listado-empresa");
    },

    getRisk(risk) {
      if (risk === "UPA") {
        return "UPA";
      } else if (risk === "group_1") {
        return "Clase I";
      } else if (risk === "group_2") {
        return "Clase II";
      } else if (risk === "group_3") {
        return "Clase III";
      } else if (risk === "group_4") {
        return "Clase IV";
      } else {
        return "Clase V";
      }
    },

    getCompany() {
      CompanyAPI.getCompanyByUUID(this.$route.params.id)
        .then((response) => {
          let company = response[0] || null;
          let sstData = company || {
            personType: null,
            uuid: null,
            arl_id: null,
            company_classification_id: 5,
            legal_representative: null,
            legal_representative_email: null,
            id_diseno_sso: null,
          };
          this.exist = response.length !== 0 ? true : false;
          if (company) {
            EmployeeAPI.getEmployeesByCompany(company.id)
              .then((response) => {
                this.employeeList = response.employee.data;
                this.totalEmployee = response.employee.total;
                this.id = company.id;
              })
              .catch((error) => {
                console.log(error);
              });
          }
          CompanySSOAPI.getCompany(this.$route.params.id)
            .then((response) => {
              let ssoData = response;
              // social_reason real viene del SSO; el del SST (columna nueva)
              // puede ser null y no debe pisarlo.
              this.companyData = { ...ssoData, ...sstData, social_reason: sstData.social_reason || ssoData.social_reason };
              this.companyData.type = this.companyData.dv == 0 ? 0 : 1;
              this.userSelected = this.companyData.id_diseno_sso;
              this.loading = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const companyID = this.companyData && this.companyData.id ? this.companyData.id : this.companyID;
        if (!companyID) return;
        // Formato generado por el backend: incluye todas las columnas actuales,
        // listas desplegables e instrucciones. Reemplaza el XLSX estatico del bucket.
        window.location.href = EmployeeAPI.getTemplateUrl(companyID);
      } catch (error) {
        console.log(error);
      }
    },

    downloadEmployeesExcel() {
      const companyID = this.companyData && this.companyData.id ? this.companyData.id : this.companyID;
      if (!companyID) return;
      const companyName = (this.companyData && (this.companyData.name || this.companyData.social_reason)) || '';
      const exportUrl = EmployeeAPI.getExportExcelUrl(companyID, this.exportStatus, companyName);
      window.location.href = exportUrl;
    },

    downloadEmployeesPdf() {
      const companyID = this.companyData && this.companyData.id ? this.companyData.id : this.companyID;
      if (!companyID) return;
      const companyName = (this.companyData && (this.companyData.name || this.companyData.social_reason)) || '';
      const exportUrl = EmployeeAPI.getExportPdfUrl(companyID, this.exportStatus, companyName);
      window.open(exportUrl, '_blank');
    },

  },
  mounted() {
    this.getCompany();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card" v-if="!loading">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title mb-4"></h4>
              </div>

              <div class="col-6 text-right">
                <router-link id="tooltip" variant="light" to="/forms/listado-empresa"
                  class="btn btn-secondary m-l-5 ml-1"><i class="fas fa-arrow-left"></i></router-link>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <b-tabs style="padding-top: 20px" justified pills class="navtab-bg">
              <b-tab title="Registro de empresa" id="company" active>
                <!-- Contenido 1 -->
                <CompanyEdit />
                <!-- fin contenido 1 -->
              </b-tab>
              <b-tab title="Registro de colaboradores" id="collab" href="#collab" v-if="exist">
                <!-- contenido 2 -->

                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="form-group m-b-0">

                      <b-row align-h="between">
                        <b-col class="text-left m-0">
                          <h4 class="header-title pt-2">Colaboradores</h4>
                        </b-col>

                        <b-col class="text-right">


                          <b-row align-h="end" align-v="center">

                            <select
                              v-model="exportStatus"
                              class="form-control form-control-sm mr-2"
                              style="width: auto; display: inline-block;"
                              title="Filtrar trabajadores a exportar"
                            >
                              <option value="all">Todos</option>
                              <option value="active">Activos</option>
                              <option value="inactive">Inactivos</option>
                            </select>

                            <button
                              type="button"
                              class="btn btn-outline-danger mr-1"
                              title="Exportar listado a PDF"
                              @click="downloadEmployeesPdf"
                            >
                              <i class="bx bxs-file-pdf"></i> PDF
                            </button>

                            <button
                              type="button"
                              class="btn btn-outline-success mr-1"
                              title="Exportar listado a Excel"
                              @click="downloadEmployeesExcel"
                            >
                              <i class="bx bxs-file-export"></i> Excel
                            </button>

                            <router-link :to="`/forms/${companyData.id}/registro-colaboradores`" class="btn btn-outline-primary">Agregar</router-link>
                            <ClassificationModal modalID="classificationModal" />
                            <cargaMasivaModal modalID="cargaMasivaModal" :company-id="companyData.id" />
                            <div class="ml-1">
                              <button class="btn btn-outline-primary" title="Descargar Formato" type="submit" @click="print">
                                <i class="bx bx-download"></i>
                              </button>
                            </div>
                          </b-row>
                        </b-col>
                      </b-row>
                    </div>

                    <Table />
                  </div>
                  <!-- end card -->
                </div>
                <!-- fin contenido 2 -->
              </b-tab>
              <b-tab title="Identidad y firmas" id="branding" v-if="exist && companyData && companyData.id">
                <div class="row pt-3">
                  <div class="col-lg-12">
                    <BrandingSection
                      :company-id="companyData.id"
                      :company-uuid="$route.params.id"
                    />
                  </div>
                  <div class="col-lg-12 mt-3">
                    <SignaturesManager :company-id="companyData.id" />
                  </div>
                  <div class="col-lg-12 mt-3">
                    <DocumentControlSection :company-id="companyData.id" />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.font-modal {
  font-size: 1.05rem;
}

.icon-badge {
  font-size: 1.8rem;
  color: darkgreen;
}
</style>
